import { createFileRoute } from "@tanstack/react-router";

import GatewayAuditPage from "@/features/dashboard/pages/gateway-audit";

const VALID_STATUS_CLASSES = ["2", "3", "4", "5"];
const VALID_CONNECTION_KEYS = ["kra", "brs", "etims"];

export type GatewayAuditSearch = {
  /** Pre-filter the trace log to one endpoint (deep link from the gateway-health instrument). */
  endpointKey?: string;
  /** Pre-filter to an HTTP status family digit (2–5). */
  statusClass?: string;
  /** Trace one exact call — deep link from a failed health check. */
  correlationId?: string;
  /** Pre-filter to one Connection (deep link from the BRS/eTIMS call-log plates). */
  connectionKey?: string;
};

export const Route = createFileRoute("/(app)/ops/kra-connection/audit")({
  component: () => <GatewayAuditPage />,
  validateSearch: (search: Record<string, unknown>): GatewayAuditSearch => {
    const endpointKey =
      typeof search.endpointKey === "string" && search.endpointKey.trim().length > 0
        ? search.endpointKey.trim()
        : undefined;
    const statusClass =
      typeof search.statusClass === "string" && VALID_STATUS_CLASSES.includes(search.statusClass)
        ? search.statusClass
        : undefined;
    const correlationId =
      typeof search.correlationId === "string" && search.correlationId.trim().length > 0
        ? search.correlationId.trim()
        : undefined;
    const connectionKey =
      typeof search.connectionKey === "string" && VALID_CONNECTION_KEYS.includes(search.connectionKey)
        ? search.connectionKey
        : undefined;
    return { endpointKey, statusClass, correlationId, connectionKey };
  },
});
